import $ from 'jquery'
import { Fancybox } from "@fancyapps/ui";

$('.wp-block-image a').attr('data-fancybox','post-gallery')

Fancybox.bind('[data-fancybox]', {
    Thumbs: false,
});

let limit = 4;

if($('.post-list article').length > 0){
    limit = $('.post-list .post:visible').length
}

$(".load-more").click(function(e) {
    if ($('.post-list .post:hidden') < limit) {
        limit = $('.post-list .post:hidden').length
    }

    $('.post-list .post:hidden').slice(0, limit).css('display', 'flex');

    if ($('.post-list .post:hidden').length == 0) {
        $(".load-more").hide();
    }
    e.preventDefault();
});


// WEBPACK FOOTER //
// ./resources/assets/js/partials/posts.js